import { expandFeatureCodes } from '@application/licence/AggregateFeatureExpansion';

export class FeatureGate {
  constructor(private readonly features: ReadonlySet<string>) {}

  static fromList(features: string[] | undefined): FeatureGate {
    return new FeatureGate(new Set(expandFeatureCodes(features)));
  }

  has(feature: string): boolean {
    return this.features.has(feature);
  }

  require(feature: string): boolean {
    return this.has(feature);
  }
}
